import * as $ from 'jquery';

// disable jQuery migrate logging
($ as any).migrateMute = true;

import 'jquery-migrate';

declare global {
 interface Window {
  jQuery: JQueryStatic;
 }
}

window.jQuery = $;

export default $;
